import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TickList } from '../../Redux/action/tickList';
import { dataUser, dataLocation } from '../Helpers/util';

import { toast } from 'react-toastify';
import axios from 'axios';
import { LocationFilterAction } from '../../Redux/action/seatAction';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
class TicketFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj.company_id,
      locationData: [],
      location: null,
      locationSpoc: [],
      locationFilter: 0,
      status: '',
      startDate: '',
      endDate: '',
    };
  }

  reload = e => {
    let raisedByValue1 = this.state.status === 'All' ? '':this.state.status
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let parm = {
      company_id: newCompanyId?.organizationId,
      location: this.state.location,
      status: raisedByValue1,
      pgno: this.props.ticketPage,
      row: this.props.ticketrow,
      location: this.state.location,
       ticketType: 'support'
    };
    this.props.TickList(parm);
    this.setState({
      location: null,
      status: '',
      startDate: '',
      endDate: '',
    });
    window.location.reload();
  };

  handelChangeVal = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handelChangeValLang = e => {
  
    this.setState({
      locationFilter: ([e.target.value]),
      location: e.target.value,
    });
  };

  submitFilter = e => {
    e.preventDefault();
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let parm = {
      company_id: newCompanyId?.organizationId,
      // location: this.state.location,
      status: this.state.status,
      pgno: this.props.ticketPage,
      row: this.props.ticketrow,
      location: (this.state.locationFilter > 0) ? this.state.locationFilter : this.state.location,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      ticketType: 'support'
    };
    this.props.TickList(parm);
    this.setState({
      location: null,
      status: '',
      startDate: '',
      endDate: '',
    });
    // let params = {
    //   location: this.state.location,
    //   status: this.state.status,
    // };

    // this.props.SetFilterData(params);
    this.props.handleLocation(this.state)
  };

  componentWillReceiveProps(props) {
    if (props.LocationList && props.LocationList.status == 200) {
      this.setState({
        locationData:
          props.LocationList &&
          props.LocationList.data &&
          props.LocationList.data.data,
      });
    }
  }

  componentDidMount() {
    let authToken = JSON.parse(localStorage.getItem('headData'));
    const { rec_id, company_id } = UserObj; // Assuming UserObj is defined somewhere

    const params = {
      spoc: rec_id,
      client: company_id
    };

    axios
      .get(`${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`, {
        params, // Correctly pass the params object here
        headers: {
          Authorization: `${authToken?.spintlyToken}`
        }
      })
      .then(res => {
        if (res.data.status === "success") {
          this.setState({
            locationSpoc: res.data.data
          });
        }
      })
      .catch(error => {
        console.error(error);
      });

    this.locationValue();
  }

  /*1---setCity---*/
  locationValue = () => {
    const formData = {
      company_id: this.state.company_id,
      // token: 'U21hcnR3b3Jrcy1GZWVkYmFjay1BUEktVjEtMjAxOQ==',
    };
    this.props.LocationFilterAction(formData);
  };

  StatusMethod = status => {
    this.setState({ status: status.value });
  };

  render() {
  
    var ticketStatus = [
      {
        value: 'Closed',
        label: 'Closed',
      },
      {
        value: 'In Progress',
        label: 'In Progress',
      },
      {
        value: 'Open',
        label: 'Open',
      },
      // {
      //   value: 'On Hold',
      //   label: 'On Hold',
      // },
    ];

    return (
      <>
        <div className="custome modal fade right" id="myModal2" data-backdrop="static">
          <div className="modal-dialog custome">
            <div className="modal-content custome">
              <div className="formTitle">
                Filter
                <button
                  type="button"
                  className="relateDox close"
                  data-dismiss="modal"
                >
                  x
                </button>
              </div>
              <div className="modal-body custome">
                <div className="addmemberformBody">
                  <form>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="formAddmemGrid">
                          <label>Location</label>
                          <select
                            className="form-control"
                            name="location"
                            onChange={this.handelChangeValLang}
                            value={this.state.location}
                          >
                            {/* <option key="all" value="all" selected>
                              All
                            </option> */}
                            <option value="">All</option>
                            {this.state.locationSpoc != null
                              ? this.state.locationSpoc.map(item => (
                                <option
                                  key={item.rec_id}
                                  value={item.rec_id}
                                >
                                  {item.location_name}
                                </option>
                              ))
                              : ''}
                          </select>
                          {/* <select
                            className="form-control"
                            name="location"
                            onChange={this.handelChangeValLang}
                            value={this.state.location}
                          >
                            <option>Select..</option>
                            {this.state.locationData.length != 0
                              ? this.state.locationData &&
                                this.state.locationData.map((items, i) => (
                                  <option value={items.location_name_zoho}>
                                    {items.location_name}
                                  </option>
                                ))
                              : null}
                          </select> */}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="formAddmemGrid">
                          <label>Status</label>
                          {/* <Select
                            name="status"
                            onChange={this.StatusMethod}
                            options={ticketStatus}
                          /> */}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="formAddmemGrid">
                          <label>Start Date </label>
                          <input
                            type="date"
                            className="formAddmemGrid browser-default custom-select"
                            name="startDate"
                            // onChange={this.changeSelect}
                            onChange={e =>
                              this.setState({ startDate: e.target.value })
                            }
                            value={this.state.startDate}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="formAddmemGrid">
                          <label>End Date </label>
                          <input
                            type="date"
                            className="formAddmemGrid browser-default custom-select"
                            name="endDate"
                            // onChange={this.changeSelect}
                            min={this.state.startDate}
                            onChange={e =>
                              this.setState({ endDate: e.target.value })
                            }
                            value={this.state.endDate}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="addmemberFooter">
                      <div className="pull-right">
                        <button
                          className="btn btn-outline-dark solCancel"
                          type="button"
                          data-dismiss="modal"
                          onClick={this.reload}
                        >
                          <i className="fa fa-refresh" aria-hidden="true" />{' '}
                          Reload
                        </button>
                        <button
                          className="btn btn-success addDetails ml10"
                          onClick={this.submitFilter}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div
          type="button"
          data-toggle="modal"
          data-target="#myModal2"
          className="filter"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            onClick={this.props.clearSearch}
            viewBox="0 0 21.345 19.36"
          >
            <path
              id="Icon_feather-filter"
              data-name="Icon feather-filter"
              d="M22.845,4.5H3l7.938,9.387v6.489l3.969,1.984V13.887Z"
              transform="translate(-2.25 -3.75)"
              fill="none"
              stroke="#333"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </svg>
        </div> */}
      </>
    );
  }
}

const mapStateToProps = state => ({
  LocationList: state.seatReducer.LocationFilterList,
});

const mapActionsToProps = {
  TickList,
  LocationFilterAction,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(TicketFilter);
